import { Form, Input, Modal } from "antd";
import log from "cslog";
import { useAtom } from "jotai";
import React, { useState, Fragment, useEffect } from "react";
import { useExternalMutation } from "../../../../actions/app/external";
import { currentComponentAtom } from "../../../../states/app/component";
import UIButton from "../../UIButton";
import Alert from "../../../../common/Alert";
import { getValidationFunc } from "../../../../_helpers/app/conditions";

export default function ButtonExternal({ action, comp_id, fields, items }) {
    const [currentComp, setCurrentComp] = useAtom(
        currentComponentAtom(comp_id)
    );
    const externalMutation = useExternalMutation();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();

    const meta = action.meta;
    const mapping = meta.mapping;
    const popup = meta.popup;

    useEffect(() => {
        if (externalMutation.isSuccess && open) {
            setOpen(false);
            externalMutation.reset();
        }
    }, [externalMutation]);

    const create = (formValues) => {
        const out = {};
        for (let [key, value] of Object.entries(mapping)) {
            switch (value.source) {
                case "fixed":
                    out[key] = value.value;
                    break;
                case "record":
                    const single_item = items[0];
                    const single_value = single_item[value.field];
                    if (
                        typeof single_value === "object" &&
                        !Array.isArray(single_value) &&
                        single_value !== null
                    ) {
                        out[key] = single_value.id;
                    } else {
                        out[key] = single_value;
                    }
                    break;
                case "popup":
                    out[key] = formValues[value.form_name];
                    break;
                default:
                    break;
            }
        }

        log.d(out, "POPUP OUT");

        externalMutation.mutate({
            path: meta.path,
            method: meta.method,
            data: out,
            refresh: meta.refresh,
        });
    };

    log.d(externalMutation, "createMutation");

    return (
        <Fragment>
            <UIButton
                layout={action.layout}
                onClick={() => {
                    popup ? setOpen(true) : create();
                }}
                loading={externalMutation.isLoading}
            />
            {popup && (
                <Modal
                    title={popup.title}
                    open={open}
                    onOk={() => {
                        form.validateFields().then((values) => {
                            create(values);
                        });
                    }}
                    okText={popup.submit}
                    confirmLoading={externalMutation.isLoading}
                    onCancel={() => {
                        setOpen(false);
                    }}
                >
                    <Form form={form}>
                        {popup.form.map((ff) => {
                            return (
                                <Form.Item
                                    name={ff.name}
                                    label={ff.label}
                                    rules={[{ required: ff.required }]}
                                >
                                    <Input />
                                </Form.Item>
                            );
                        })}
                    </Form>
                    {externalMutation.isError && (
                        <Alert
                            type="error"
                            message={`Record couldn't be created`}
                            bold={false}
                        />
                    )}
                </Modal>
            )}
        </Fragment>
    );
}
